<script>
import {mapState, mapActions, mapGetters, mapMutations} from "vuex";
import Carousel from "../components/Carousel";
import LotViewBidding from "../components/configuration/lot-view/LotViewBidding";
import LotInfo from "../components/LotInfo";
import SocialShareIcons from "../components/lot-view/SocialShareIcons";
import LotViewSkeleton from "../components/lot-view/LotViewSkeleton"
import LatestBidsModal from "../components/lot-view/LatestBidsModal";
import SocialSharePopup from "@/components/lot-view/sidebar/SocialSharePopup";
import WatchlistButton from "@/components/lot-view/sidebar/WatchlistButton";
import WatchlistCount from "@/components/lot-view/sidebar/WatchlistCount";
import logger from "../logger";
import templatable from "@/mixins/templatable";
import PlaceBidModal from "@/components/lot-view/PlaceBidModal";
import TriggerBidBuyModalButton from "@/components/lot-view/TriggerBidBuyModalButton";
import dynamicFieldsMixin from "@/mixins/dynamicFieldsMixin";
import {lotView} from "@/triggers";
import lotHelperMixin from "@/mixins/lotHelperMixin";
import auctionBaseMixin from "@/mixins/auctionBaseMixin";
import AuctionPauseMessage from "@/views/AuctionListPage/list-item/AuctionPauseMessage.vue";
import AuctionTermsLink from "@/views/AuctionViewPage/AuctionTermsLink.vue";
import AuctionViewingInformationLink from "@/views/AuctionViewPage/AuctionViewingInformationLink.vue";
import AuctionCollectionInformationLink from "@/views/AuctionViewPage/AuctionCollectionInformationLink.vue";
import lotBaseMixin from "@/mixins/lotBaseMixin";

export default {
  name: "RedirectView",

  components: {
  },
  data: () => ({
    notFound: false,
    scrolled: 0,
    template: `
      <div ref="page" class="ta-lot-view">
        <div v-if="notFound" class="ta-lot-not-found">
            <h3 class="text-center">404, {{ $t('Not Found 404') }}</h3>
        </div>
      </div>`
  }),
  computed: {
    ...mapState(['mainConfig']),
  },
  watch: {
    '$route.query': {
      immediate: true,
      async handler() {
        this.notFound = false;
        const response = await this.getRedirectData({...this.$route.params, ...this.$route.query});
        if (response.status === 404) {
          this.notFound = true;
        } else if (response.status === 200) {
          const redirectMap = {
            'inventory': 'LotView'
          }
          console.log(response.data);
          this.$router.replace({name: redirectMap[this.$route.params.type], params: {'lotno': response.data.redirect}});
        }
      },
    }
  },
  methods: {
    ...mapActions(['getRedirectData']),
  },
  render(h, context) {
    if (!this.templateRender) {
      return h('div', 'Loading...')
    }
    return this.templateRender();
  },
}
</script>

<style scoped lang="scss">
@import "../bootstrap/import";
@import "../scss/mixins";

#artisioTimedAuctions {

}
</style>
